import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    potencia_inmovil:false
  },
  getters: {
  },
  mutations: {
    setPotenciaInmovil(state,valor){
      state.potencia_inmovil=valor;
    }
  },
  actions: {
    setPotenciaInmovil({commit},valor){
      commit('setPotenciaInmovil',valor)
    }
  },
  modules: {
  }
})
